import React, { useState } from 'react'
import { Card, Tabs, Upload, Button, Input, Tag, Spin } from 'antd'
import { CameraOutlined, SearchOutlined } from '@ant-design/icons'
import type { UploadFile } from 'antd/es/upload/interface'
import './MedicineRecognition.css'

const { TabPane } = Tabs
const { TextArea } = Input

const MedicineRecognition: React.FC = () => {
  const [fileList, setFileList] = useState<UploadFile[]>([])
  const [recognizing, setRecognizing] = useState(false)
  const [result, setResult] = useState<any>(null)

  const handleUpload = async () => {
    setRecognizing(true)
    // 调用识别API
    setTimeout(() => {
      setRecognizing(false)
      setResult({
        name: '人参',
        confidence: 0.95,
        properties: {
          nature: '温',
          flavor: '甘、微苦',
          meridian: '归脾、肺、心、肾经',
          efficacy: '大补元气，复脉固脱，补脾益肺，生津养血，安神益智',
        },
      })
    }, 2000)
  }

  return (
    <div className="medicine-recognition-page">
      <Card className="recognition-card">
        <Tabs defaultActiveKey="image">
          <TabPane tab="中药饮片识别" key="image">
            <div className="upload-section">
              <Upload
                listType="picture-card"
                fileList={fileList}
                onChange={({ fileList }) => setFileList(fileList)}
                beforeUpload={() => false}
                maxCount={1}
              >
                {fileList.length < 1 && (
                  <div>
                    <CameraOutlined style={{ fontSize: 32, color: '#C62828' }} />
                    <div style={{ marginTop: 8 }}>点击上传或拍照</div>
                  </div>
                )}
              </Upload>
              <Button
                type="primary"
                size="large"
                icon={<SearchOutlined />}
                onClick={handleUpload}
                loading={recognizing}
                disabled={fileList.length === 0}
                className="recognize-button"
              >
                开始识别
              </Button>
            </div>

            {recognizing && (
              <div className="recognizing">
                <Spin size="large" />
                <p>正在识别中...</p>
              </div>
            )}

            {result && (
              <Card className="result-card" title="识别结果">
                <div className="result-content">
                  <h3>{result.name}</h3>
                  <Tag color="green">置信度：{(result.confidence * 100).toFixed(0)}%</Tag>
                  <div className="result-properties">
                    <p><strong>性味：</strong>{result.properties.nature} {result.properties.flavor}</p>
                    <p><strong>归经：</strong>{result.properties.meridian}</p>
                    <p><strong>功效：</strong>{result.properties.efficacy}</p>
                  </div>
                </div>
              </Card>
            )}
          </TabPane>

          <TabPane tab="方剂识别" key="prescription">
            <div className="prescription-input">
              <TextArea
                rows={8}
                placeholder="请输入方剂名称或组成，例如：四君子汤、人参、白术、茯苓、甘草"
              />
              <Button
                type="primary"
                size="large"
                icon={<SearchOutlined />}
                onClick={handleUpload}
                className="recognize-button"
                style={{ marginTop: 16 }}
              >
                识别方剂
              </Button>
            </div>
          </TabPane>
        </Tabs>
      </Card>
    </div>
  )
}

export default MedicineRecognition

